// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1C98i","savePackageButton":"ClientWallet_savePackageButton__1ANIM"};